// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2B1y1","tabsBox":"styles_tabsBox__3NtnE","createButton":"styles_createButton__2aVei"};